module.exports = __webpack_public_path__ + "assets/7b9c7142dfa2e8d39a4e3ed3b4ccdda9.png";